module.exports = __webpack_public_path__ + "img/bg4s_m.223fec4d.png";